import { Container, Row, Col } from 'react-bootstrap';
import PageHero from '../components/PageHero';

import NewsletterRibbon from '../components/NewsletterRibbon';

const workingGroups = [
  {
    title: 'Aerosol Technology',
    intro: (
      <>
        Aerosol Technology includes research and development fields ranging from conventional areas, such as{' '}
        <span className="text-marker">
          emission control, filtration and powder technology
        </span>
        , to more recent ones such as advances in{' '}
        <span className="text-marker">
          functional nanomaterials and Industry 4.0 systems
        </span>
        .
      </>
    ),
    topics: [
      'Synthesis, structuring and applications of functional nanoparticles',
      'Nanoparticle surface modification, deposition and thin film formation',
      'Process analysis and monitoring',
      'Transportation aerosol emissions and control technologies; combustion aerosols from vehicles, airplanes and ships',
      'Electrical effects including electrosprays and electric discharges',
      'High temperature aerosols and biomass combustion',
      'Filtration for functional materials, combustion and industrial aerosols',
      'Aerosol and emissions standards',
    ],
  },
  {
    title: 'Atmospheric Aerosol Studies',
    intro: (
      <>
        Atmospheric Aerosol Studies includes everything{' '}
        <span className="text-marker">
          from field campaigns to aerosol chamber, laboratory and modelling studies
        </span>{' '}
        considering any aspect of atmospheric aerosols and their processing.
      </>
    ),
    topics: [
      'Aerosols and clouds in polar regions',
      'Aerosol-cloud interaction, ice nucleation and role in climate feedbacks',
      'New particle formation',
      'Homogeneous, heterogeneous and multiphase chemistry; secondary aerosols',
      'Transport of atmospheric aerosols, modelling and climate forcing',
      'Molecular characterization of atmospheric aerosols',
      'Chemical characterization of carbonaceous aerosols',
      'Source apportionment of atmospheric aerosols',
      'Aerosol optical properties, atmospheric light absorption and remote sensing',
      'Physico-chemical properties of atmospheric aerosols',
    ],
  },
  {
    title: 'Aerosol Measurement Techniques',
    intro: (
      <>
        Aerosol Measurement Techniques includes all aspects related to the{' '}
        <span className="text-marker">measurement</span> of aerosols and their properties, and the{' '}
        <span className="text-marker">evaluation</span> of the resulting data, covering a wide range of applications from atmospheric to workplace and process aerosols.
      </>
    ),
    topics: [
      'Instrument and sampler calibration and performance evaluation',
      'Instrumentation for physical, chemical and biological aerosol characterization',
      'Novel measurement principles and new instrumentation',
      'Miniaturized and low-cost instrumentation',
      'Comparison of different measurement methods',
      'Measurement techniques for combustion aerosols',
      'Implementation of existing measurement methods and instruments for novel studies',
      'Interpretation of data',
    ],
  },
  {
    title: 'Aerosols and Health',
    intro: (
      <>
        Aerosols and Health includes diverse research from fields such as physics, chemistry, medicine, biology, pharmacy, toxicology, epidemiology, exposure science and engineering, investigating{' '}
        <span className="text-marker">adverse health effects</span> of outdoor, indoor and workplace aerosols, or their{' '}
        <span className="text-marker">therapeutic uses</span>.
      </>
    ),
    topics: [
      'Exposure: sources, levels and assessment techniques',
      'Human exposure and health effects of aerosols',
      'Health-relevant aerosols and their characteristics',
      'Bioaerosols and allergens',
      'Biological and toxicological responses',
      'Medical and therapeutic applications',
      'Respiratory tract uptake, translocation and clearance',
      'Exposure in specific microenvironments',
      'Occupational exposures',
    ],
  },
  {
    title: 'Basic Aerosol Processes',
    intro: (
      <>
        Basic Aerosol Processes includes{' '}
        <span className="text-marker">fundamental aerosol research</span> related to aerosol physics and chemistry, modelling and simulations, including research into aerosol and material properties relevant to atmospheric chemists, material scientists and others.
      </>
    ),
    topics: [
      'Smog chamber and flowtube simulations and experiments',
      'Quantum chemistry and molecular dynamics simulations of aerosol formation',
      'Aerosol nucleation, growth, evaporation, agglomeration and fragmentation',
      'Aerosol transport, resuspension, deposition and fluid dynamics',
      'Data science, big data and machine learning in aerosol research',
      'Modelling, experiments, detection and analysis techniques of bioaerosols',
    ],
  },
];

export default function InfoTopicsSpecialSessions() {
  return (
    <div className="page-content">
      <PageHero
        eyebrow="Conference info"
        title="Topics and Special Sessions"
        intro="The scientific programme of EAC2027 is organized around the five Working Groups of the European Aerosol Assembly."
      />

      <main className="info-page py-5">
        <Container className='pt-5'>
          <Row className="justify-content-center">
            <Col lg={10} xl={9}>
              <section className="info-section">
                <h2 className='h1'>Scientific programme</h2>
                <p>
                  The scientific programme of EAC2027 reflects five major research directions in aerosol science, which are
                  represented by the five Working Groups of the <a href="https://www.info.gaef.de/eaa#dataItem-ky0dff7e" target="_blank" rel="noreferrer">European Aerosol Assembly</a>: Aerosol Technology (WG1),
                  Atmospheric Aerosol Studies (WG2), Aerosol Measurement Techniques (WG3), Aerosols and Health (WG4),
                  and Basic Aerosol Processes (WG5).
                  </p>
                  
                  <p>
                  Besides regular topics covered by the Working Groups, several special sessions will be organized by community members, emphasizing emerging topics in the field.
                </p>
              </section>

              <NewsletterRibbon />


              {workingGroups.map((group) => (
                <section className="info-section" key={group.title}>
                  <h2>{group.title}</h2>
                  <p>{group.intro}</p>

                  <h3 className='mt-4'>Topics</h3>
                  <ol className="info-list">
                    {group.topics.map((topic) => (
                      <li key={topic}>{topic}</li>
                    ))}
                  </ol>
                </section>
              ))}

              <section className="info-section">
                <h2>Special sessions</h2>
                <p>
                  Special sessions emphasize emerging topics in aerosol research and often result from the collaboration between different Working Groups.
                </p>
              </section>
            </Col>
          </Row>
        </Container>
      </main>
    </div>
  );
}